import { isEmpty, isNil } from 'lodash';
import { DefaultError } from '@shared/components/DefaultError';
import { View } from '@shared/components/View';
import { CardEntityError } from '@shared/scenes/entity/create/hooks/useFormErrors';
import classNames from './FormErrors.module.css';

export function FormErrors({ errors }: { errors: CardEntityError[] }) {
  const formErrors = errors.filter(error => isNil(error.componentId));

  if (isEmpty(formErrors)) {
    return null;
  }

  return (
    <View fullWidth>
      {formErrors.map((error, index) => (
        <DefaultError
          key={`${error.description}-${index}`}
          message={error.description ?? ''}
          isRounded={false}
          className={classNames.error}
        />
      ))}
    </View>
  );
}
